import React from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

export default function GameControls({ isPaused, onPause, onRestart, onToggleAudio, audioOn, onToggleInfo }) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <Button
        variant={isPaused ? 'default' : 'outline'}
        size="sm"
        iconName={isPaused ? 'Play' : 'Pause'}
        iconPosition="left"
        iconSize={15}
        onClick={onPause}
        aria-label={isPaused ? 'Resume game' : 'Pause game'}
      >
        <span className="hidden sm:inline">{isPaused ? 'Resume' : 'Pause'}</span>
      </Button>
      <Button
        variant="outline"
        size="sm"
        iconName="RotateCcw"
        iconPosition="left"
        iconSize={15}
        onClick={onRestart}
        aria-label="Restart game"
      >
        <span className="hidden sm:inline">Restart</span>
      </Button>
      <button
        onClick={onToggleAudio}
        className="flex items-center justify-center w-8 h-8 rounded-lg border transition-all hover:bg-[var(--color-muted)]"
        style={{ borderColor: 'var(--color-border)', color: audioOn ? 'var(--color-foreground)' : 'var(--color-muted-foreground)' }}
        aria-label={audioOn ? 'Mute audio' : 'Unmute audio'}
        title={audioOn ? 'Mute' : 'Unmute'}
      >
        <Icon name={audioOn ? 'Volume2' : 'VolumeX'} size={15} />
      </button>
      <button
        onClick={onToggleInfo}
        className="flex items-center justify-center w-8 h-8 rounded-lg border transition-all hover:bg-[var(--color-muted)]"
        style={{ borderColor: 'var(--color-border)', color: 'var(--color-muted-foreground)' }}
        aria-label="Game info"
        title="Game Info"
      >
        <Icon name="Info" size={15} />
      </button>
    </div>
  );
}